import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Map, MapMarker } from 'react-kakao-maps-sdk';

import { getKakaoMapAppKey, loadKakaoMapScript } from '@/utils/loadKakaoMap';

import * as S from './style';

const MAP_CENTER = { lat: 36.330068, lng: 127.339479 };

const Maps = () => {
	const { t } = useTranslation();
	const appKey = getKakaoMapAppKey();
	const [mapReady, setMapReady] = useState(false);
	const [mapError, setMapError] = useState(false);

	useEffect(() => {
		if (!appKey) {
			setMapError(true);
			return;
		}

		loadKakaoMapScript(appKey)
			.then(() => setMapReady(true))
			.catch(() => setMapError(true));
	}, [appKey]);

	return (
		<S.MapContainer>
			<S.ContentBox>
				<S.ContentTitle>{t('introduce.maps.title')}</S.ContentTitle>
				<S.MapsContent>
					<span>{t('introduce.maps.address')}</span>
					<span>{t('introduce.maps.tel')}</span>
					<span>{t('introduce.maps.homepage')}</span>
					<span>{t('introduce.maps.email')}</span>
				</S.MapsContent>
				<div>
					<S.ImgMapBox style={{ width: '100%', maxWidth: '844px' }}>
						{mapReady && !mapError ? (
							<Map center={MAP_CENTER} style={{ width: '100%', height: '400px' }} level={3}>
								<MapMarker position={MAP_CENTER} />
							</Map>
						) : (
							<S.MapPlaceholder>
								{mapError ? t('introduce.maps.mapUnavailable') : t('introduce.maps.mapLoading')}
							</S.MapPlaceholder>
						)}
					</S.ImgMapBox>
				</div>
			</S.ContentBox>
		</S.MapContainer>
	);
};

export default Maps;
